import { css } from "../../../component-styles";

export const cool = css`
  :host {
    --bg: #ffffff;
    --bg-elevated: #ffffff;
    --text-pri: #111111;
    --text-sec: #666666;
    --text-ter: #999999;
    --divider: rgba(0, 0, 0, 0.06);
    --hover-color: rgba(0, 0, 0, 0.03);
    --blue: #2563eb;
  }
`;
